import { useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationService } from '@services/organization';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useToggleInvoicingPaused = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['organizations', 'toggleInvoicingPaused'],
    mutationFn: async ({
      organizationId,
      paused,
    }: {
      organizationId: string;
      paused: boolean;
    }) => {
      return await organizationService.setInvoicingPaused(organizationId, paused);
    },
    onSuccess: (_, { paused }) => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast.success(
        paused
          ? tActionMessages.invoicingPausedForOrganization
          : tActionMessages.invoicingResumedForOrganization,
      );
    },
    onError: (error: any) => {
      console.error('Toggle invoicing paused error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.message ||
        error?.toString() ||
        'Failed to update invoicing status';
      toast.error(errorMessage);
    },
  });
};

export default useToggleInvoicingPaused;
